import { useCallback, useMemo, useState } from "react";
import { ImageModal } from "components";

const initialImageModalProps = {
	open: false,
	src: null,
};

const useImageModal = () => {
	const [imageModalProps, setImageModalProps] = useState(initialImageModalProps);
	const openModal = useCallback((src) => {
		setImageModalProps({ open: true, src });
	}, []);

	const closeModal = useCallback((src) => {
		setImageModalProps(initialImageModalProps);
	}, []);

	const _ImageModal = useCallback(
		() => (
			<ImageModal open={imageModalProps.open} hideModal={closeModal}>
				<img src={imageModalProps.src} alt="" />
			</ImageModal>
		),
		[imageModalProps]
	);

	return { ImageModal: _ImageModal, openModal, closeModal };
};

export default useImageModal;
